import { SoundConstant, SoundConstant as SoundConstantBehavior } from "@quest/murka-games-behavior-leopard/dist";

export class SoundConstantGame extends SoundConstantBehavior {
  public static RETRIGGER_POP_UP_SOUND: string = "fs_add";
  public static ANTICIPATION_SOUND: string = "intrigue";
  public static ANTICIPATION_REEL_STOP: string = "intrigue_stop";
  public static MUSIC_SPIN: string = "music_spin";
  public static FREE_GAME_BGM: string = "music_freespin";
  public static VOICE_INTRO: string = "voice_Welcome_to_hell_sinner";
  public static CHAR_UNITE: string = "icon_merge";
  public static STACK_WIN: string = "demon_win";  
  public static WILD_WIN: string = "wild_win_1x1";
  public static BIG_WIN_VOICE = "voice_Im_unstoppable_1";
  public static BIG_WIN_LOOP: string = "big_win_ode_to_joy";
  public static BIG_WIN_END_SOUND: string = "big_win_end";
  public static BIG_WIN_INTRO:string="big_win_intro"
  public static MINIGAME_MUSIC :string="fs_need_choose";
  public static MINIGAME_CHOOSE:string="card_choose";
  public static MINIGAME_POPUP_APPEAR:string="minigame_popup_appear";
  public static MINIGAME_POPUP_DISAPPEAR:string="card_disappear";
  public static WILD_1X4_APPEAR:string="wild_spawn";
  public static WILD_1X4_WIN:string="wild_win_1x4";
  public static WILD_1X4_FEED:string="wild_idle";
  public static WILD_1X4_LOCK:string="reel_wild_spawn";
  public static FS_WILD_1X4_LOCK:string="reel_wild_spawn";
  public static SPECIAL_LANDING: string= "skull_appear_1";
  public static SPECIAL_PARTICLE:string="special_particle";
  public static SPECIAL_PROGRESS: string="skull_collect1";
  public static SPECIAL_DEACTIVATE:string="skull_burn";
  public static WILD_WIN_VOICE_1:string="voice_This_world_must_burn_1";
  public static FS_WIN:string="fs_win";
  public static SFX_WILD:string="wild_win_1x1";
  public static WIN_LINE_SOUND: string = "win_lines_step_1";
  public static FREEGAME_INTRO_VOICE: string = "voice_So_damn_good_1";
}
SoundConstant.SCATTER_LANDING = "free_spins_symbol_";
SoundConstant.BIG_WIN_START = "big_win_slot";
SoundConstant.FREE_GAME_INTRO = "fs_popup_start";
SoundConstant.FREE_GAME_OUTRO="fs_popup_win";
SoundConstant.FREGAME_BGLOOP = "music_freespin"